import { render } from "./HomeSdg.vue?vue&type=template&id=10600cce&scoped=true"
import script from "./HomeSdg.vue?vue&type=script&lang=js"
export * from "./HomeSdg.vue?vue&type=script&lang=js"

import "./HomeSdg.vue?vue&type=style&index=0&id=10600cce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10600cce"]])

export default __exports__